import { __assign, __awaiter, __generator, __read } from "tslib";
import React, { useState } from 'react';
import ReactDom from 'react-dom';
import { IllustrationMiddleLoadFailed, OutlinedDirectionRefresh } from '@hose/eui-icons';
import { Button } from '@hose/eui';
import styles from './LoadingError.module.less';
var LoadingError = function (props) {
    var text = props.text, refreshFn = props.refreshFn;
    var _a = __read(useState(false), 2), isRetry = _a[0], setIsRetry = _a[1];
    var handleRefresh = function () { return __awaiter(void 0, void 0, void 0, function () {
        var e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    if (isRetry)
                        return [2];
                    setIsRetry(true);
                    return [4, (refreshFn === null || refreshFn === void 0 ? void 0 : refreshFn())];
                case 1:
                    _a.sent();
                    return [3, 4];
                case 2:
                    e_1 = _a.sent();
                    return [3, 4];
                case 3:
                    setIsRetry(false);
                    return [7];
                case 4: return [2];
            }
        });
    }); };
    return (React.createElement("div", { className: styles['loading-error-wrapper'] },
        React.createElement(IllustrationMiddleLoadFailed, { fontSize: 200 }),
        React.createElement("div", { style: {
                marginBottom: 12
            } }, text || i18n.get('加载失败，请重新刷新')),
        React.createElement(Button, { category: "secondary", theme: "highlight", size: "middle", icon: React.createElement(OutlinedDirectionRefresh, { fontSize: 20 }), onClick: handleRefresh }, i18n.get('刷新'))));
};
export var injectErrorDom = function (container, props) {
    if (props === void 0) { props = {}; }
    if (!container)
        return null;
    var div = document.createElement('div');
    div.style.cssText = "\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      width: 100%;\n      text-align: center;\n      z-index: 9;\n      -webkit-transform: translate(-50%, -50%);\n              transform: translate(-50%, -50%);\n  ";
    ReactDom.render(React.createElement(LoadingError, __assign({}, props)), div);
    container.appendChild(div);
    return function () {
        div.parentElement.removeChild(div);
    };
};
export default LoadingError;
